

import './index.less';
import * as React from 'react';

interface PropTypes {
	isOpen?: boolean;
	content: any;
	onClose?: (...args: any) => void
}
export default class Model extends React.Component<PropTypes, any>{
	static defaultProps = {
		isOpen: false,
		content: {},
		onClose: () => { }
	}
	constructor(props: PropTypes) {
		super(props)
		console.log(this.props);
		this.state = {
			isOpen: this.props.isOpen,
			content: this.props.content
		}
	}

	closePop() {
		this.props.onClose();
	}

	componentWillReceiveProps(nextProps: any) {
		this.setState({
			isOpen: nextProps.isOpen,
			content: nextProps.content
		})
	}

	render() {
		const { isOpen, content } = this.state;
		return (
			<div className={isOpen ? 'model' : 'model-none'} onClick={this.closePop.bind(this)}>
				<div className="model-content">
					<img className="model-img" src={content.url} alt={content.title} />
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/component/model/index.tsx